module.exports = __webpack_public_path__ + "static/media/being_four.bc7a0901.png";